export function createSearchOverlayController(deps) {
  function resolveAnalyticsSearchResultsElement() {
    const modalResults = deps.getAnalyticsResultsElement?.();
    return modalResults instanceof HTMLElement ? modalResults : null;
  }

  function resolveProgramTemplateResultsElement() {
    const resultWrap = deps.getProgramTemplateResultsElement?.();
    return resultWrap instanceof HTMLElement ? resultWrap : null;
  }

  function renderExerciseSearchResultsInPlace(
    searchItems,
    context = deps.getExerciseSearchModalContext(),
  ) {
    const resultWrap = resolveAnalyticsSearchResultsElement();
    if (!resultWrap) {
      return;
    }

    deps.setElementHtml(
      resultWrap,
      deps.renderExerciseSearchResults(searchItems, {
        action:
          deps.exerciseSearchModalContexts?.[context]?.action
          || deps.exerciseSearchModalContexts?.analytics?.action
          || "",
      }),
    );
  }

  function renderProgramTemplateSearchResultsInPlace(query = "") {
    const resultWrap = resolveProgramTemplateResultsElement();
    if (!resultWrap) {
      return;
    }

    deps.setElementHtml(
      resultWrap,
      deps.renderProgramTemplateSearchResults(deps.programTemplates, query),
    );
  }

  function resetAnalyticsSearchState(context = deps.getExerciseSearchModalContext()) {
    if (context === "analytics") {
      deps.mutateState((state) => {
        state.analytics = {
          ...(state.analytics || {}),
          query: "",
          searchItems: [],
        };
      }, true);
    }
    renderExerciseSearchResultsInPlace([], context);
  }

  function applyAnalyticsSearchResults(query, searchItems) {
    const nextQuery = String(query || "").trim();
    const nextItems = Array.isArray(searchItems) ? searchItems : [];

    deps.mutateState((state) => {
      state.analytics = {
        ...(state.analytics || {}),
        query: nextQuery,
        searchItems: nextItems,
      };
    }, true);
    renderExerciseSearchResultsInPlace(nextItems, "analytics");
  }

  function updateProgramTemplateQuery(query) {
    const nextQuery = String(query || "").trim();
    deps.setState({
      programTemplateQuery: nextQuery,
    });
    renderProgramTemplateSearchResultsInPlace(nextQuery);
  }

  return {
    applyAnalyticsSearchResults,
    renderExerciseSearchResultsInPlace,
    renderProgramTemplateSearchResultsInPlace,
    resetAnalyticsSearchState,
    updateProgramTemplateQuery,
  };
}
